import React from 'react'
import { Link } from 'react-router-dom'

export const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: "Sarah M.",
      location: "Florida",
      timeshare: "Wyndham",
      savings: "$12,000",
      time: "4 months",
      quote: "After my attorney failed and kept my $12,000, I found this guide. It worked in 4 months! I wish I had found this first. The step-by-step process was so clear, and I finally understood what was happening with my case.",
      rating: 5
    },
    {
      name: "Michael R.",
      location: "Texas",
      timeshare: "Marriott",
      savings: "$8,500",
      time: "3 months",
      quote: "Paid an attorney $8,500 upfront - nothing happened for 8 months. Used this guide and got results in 3 months. The legal templates are exactly what attorneys use. Why didn't anyone tell me this was possible?",
      rating: 5
    },
    {
      name: "Jennifer L.",
      location: "California",
      timeshare: "Hilton",
      savings: "$15,200",
      time: "5 months",
      quote: "The attorney wanted $15,200 and couldn't guarantee anything. This guide cost $997 and worked perfectly. I followed every step and Hilton finally released me. The maintenance fee stop strategy alone saved me thousands.",
      rating: 5
    },
    {
      name: "David & Linda K.",
      location: "Arizona",
      timeshare: "Disney",
      savings: "$11,000",
      time: "6 months",
      quote: "We almost hired an attorney for $11,000. So glad we found this instead! The Disney-specific strategies worked exactly as described. We're free and saved over $10,000. This guide pays for itself 10 times over.",
      rating: 5
    },
    {
      name: "Robert T.",
      location: "Nevada",
      timeshare: "Westgate",
      savings: "$9,800",
      time: "4 months",
      quote: "I was skeptical at first - seemed too good to be true. But after getting burned by one attorney already, I tried it. The legal foundation is solid, and the results speak for themselves. Finally free!",
      rating: 5
    },
    {
      name: "Maria S.",
      location: "New York",
      timeshare: "Bluegreen",
      savings: "$7,500",
      time: "3 months",
      quote: "The guide is incredibly detailed and professional. I felt confident following each step because everything was explained clearly. The email support helped when I had questions. Worth every penny!",
      rating: 5
    }
  ]

  return (
    <section id="testimonials" className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">
            Real People, <span className="text-blue-600">Real Results</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't take our word for it. Here are real success stories from people who escaped 
            their timeshares using our guide instead of expensive attorneys.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              {/* Rating Stars */}
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg key={i} className="w-5 h-5 text-blue-600 fill-current" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              
              {/* Quote */}
              <blockquote className="text-gray-700 text-sm mb-4 leading-relaxed">
                "{testimonial.quote}"
              </blockquote>
              
              {/* Attribution */}
              <div className="border-t border-gray-200 pt-4">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <div className="font-semibold text-gray-900">{testimonial.name}</div>
                    <div className="text-xs text-gray-500">{testimonial.location}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-medium text-blue-600">Saved {testimonial.savings}</div>
                    <div className="text-xs text-gray-500">{testimonial.time} exit</div>
                  </div>
                </div>
                <div className="text-xs text-blue-600 font-medium">
                  {testimonial.timeshare} Timeshare
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Summary Stats */}
        <div className="bg-blue-50 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Join Thousands of Successful Exits
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-1">4,847+</div>
              <div className="text-gray-600 text-sm">Total Successful Exits</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-1">$9,200</div>
              <div className="text-gray-600 text-sm">Average Savings vs. Attorneys</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-1">4.2</div>
              <div className="text-gray-600 text-sm">Average Months to Exit</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-1">97.8%</div>
              <div className="text-gray-600 text-sm">Success Rate</div>
            </div>
          </div>
          
          <div className="bg-blue-100 border border-blue-300 rounded-lg p-4 mb-6">
            <p className="text-blue-800 font-medium">
              ✨ <strong>Professional Opportunity:</strong> Get the same results for just $997 instead of paying attorneys $5,000-$15,000
            </p>
          </div>
          
          <Link 
            to="/register"
            className="btn-primary text-xl px-12 py-4 no-underline inline-block"
          >
            Get Your Professional Guide Now - Join the Success Stories
          </Link>
        </div>
      </div>
    </section>
  )
}